import React from 'react';
import bemHelper from 'react-bem-helper';

import { replaceStyleImageUri } from '../../utils';
import * as constants from '../../constants';
import SectionTextModule from '../SectionTextModule/SectionTextModule';
import './styles.scss';

const bem = bemHelper({ prefix: 'toga-', name: 'storefront-about' });

class AboutModule extends React.Component {

  render() {
    const { title, summary, text, image, highlightedWords } = this.props;
    const hasImage = !!(image && image.url);

    return (
      <div {...bem(null, { 'has-image': hasImage })}>

        {hasImage && <div {...bem('left')}>
          <div {...bem('image')}>
            <img
              srcSet={`${replaceStyleImageUri(image.url, constants.IMAGE_SIZE_NORMAL)}, ${replaceStyleImageUri(image.url, constants.IMAGE_SIZE_RETINA)} 2x`}
              src={replaceStyleImageUri(image.url, constants.IMAGE_SIZE_NORMAL)}
              alt={image.altText}/>
          </div>

          {
            highlightedWords &&
            <div {...bem('highlight')}>{highlightedWords}</div>
          }
        </div>}

        <SectionTextModule {...bem('text', { columns: !hasImage })}
                           title={title}
                           summary={summary}
                           body={text}/>

      </div>
    );
  }

}

export default AboutModule;




// WEBPACK FOOTER //
// ./src/components/storefront/components/AboutModule/AboutModule.js